module.exports = __webpack_public_path__ + "static/superchargeWorkflow@2x-c590dc9675fc826caa7e716cf8729c90.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/developers/superchargeWorkflow@2x.png
// module id = 2558
// module chunks = 168707334958949